import React from 'react';
import PropTypes from 'prop-types';
import AmiTasksService from './AmiTasksService';
import { AmiTaskFilter } from './AmiTaskFilter';
import { withRouter } from 'react-router-dom';
import { AmiTaskPanelItem } from './AmiTaskPanelItem';
import { ButtonGroup, Button } from 'reactstrap';
import { isAmiUserAuthorizedToManageTasks } from '../authorization/amiPermissions';

class AmiTaskPanel extends React.Component {

  static propTypes = {
    idrelated: PropTypes.string.isRequired,
    isOrder: PropTypes.bool.isRequired,
    enabledAddNew: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
    filter: new AmiTaskFilter(),
    items: [],
  };

  async componentDidMount() {
    this.search();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idrelated !== prevProps.idrelated) {
      this.search();
    }
  }

  search() {
    const { filter } = this.state;
    const { isOrder } = this.props;

    filter.search = this.props.idrelated;
    filter.includeOrderLine = isOrder;
    this.setState({ filter });

    this.loadTasks();
  }

  loadTasks() {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    AmiTasksService.search(this.state.filter).then((items) =>
      this.setState({
        items: items,
        loading: false,
      })
    );
  }

  handleOnOpenView = (amiTaskId) => {
    if (!amiTaskId) {
      throw Error('Cannot edit Task. Invalid id specified.');
    }
    this.props.history.push(`/ami-tasks/view/${amiTaskId}`);
  };

  newAmiTask = () => {
    const { idrelated, isOrder } = this.props;
    if (isOrder) this.props.history.push(`/ami-tasks/new/Order/${idrelated}`);
    else this.props.history.push(`/ami-tasks/new/Quote/${idrelated}`);
  };

  render() {
    const { items } = this.state;
    const { enabledAddNew } = this.props;
    return (
      <div className="col">
        <div className="card mb-3 box-shadow">
          <div className="card-body">
            <h6 className="card-title text-center">Tasks</h6>
            {items.length === 0 && (
              <div className="row">
                <div className="col text-center">No tasks</div>
              </div>
            )}
            <div className="recent-list-wrapper pb-0">
              <ul className="list-unstyled">
                {items.length !== 0 &&
                  items
                    .slice(0)
                    .reverse()
                    .map((amiTask, i) => (
                      <AmiTaskPanelItem
                        key={items.length - i}
                        amiTask={amiTask}
                        onOpenView={this.handleOnOpenView}
                      />
                    ))}
              </ul>
            </div>
            {enabledAddNew && isAmiUserAuthorizedToManageTasks() && (
              <div className="row">
                <div className="col text-center">
                  <ButtonGroup>
                    <Button color="outline-primary" onClick={this.newAmiTask}>
                      New Task
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AmiTaskPanel);
